import React, { useState, useRef } from "react";
import Footer from "../../components/footer";
import Scrollbar from "../../components/scrollbar";
import FloatingHearts from "../../components/floating-hearts";
import Preloader from "../../components/preloader";
import "./App.css";
import AllRoute from "../router";

// Bài "Xứng Đôi Cưới Thôi" - Nhạc cưới
const MUSIC_URL = "https://docs.google.com/uc?export=download&id=1hfEqqAJOL3sjD1M1v9TNkgQNI6hji5C_";

const App = () => {
  const [showPreloader, setShowPreloader] = useState(true);
  const audioRef = useRef(null);

  const handlePlayMusic = () => {
    if (audioRef.current) {
      audioRef.current.volume = 0.5;
      audioRef.current.play().catch(e => console.log("Audio play failed:", e));
    }
  };

  return (
    <div className="App">
      {/* Background Music */}
      <audio ref={audioRef} loop>
        <source src={MUSIC_URL} type="audio/mpeg" />
      </audio>

      {showPreloader && (
        <Preloader 
          onComplete={() => setShowPreloader(false)} 
          onPlayMusic={handlePlayMusic}
        />
      )}
      <div style={{ visibility: showPreloader ? 'hidden' : 'visible' }}>
        <AllRoute />
        <Footer />
        <Scrollbar />
        <FloatingHearts />
      </div>
    </div>
  );
};

export default App;

